import { Loading } from "@/components";
import { FONT, MEDIA } from "@/styles/common";
import theme from "@/styles/theme";
import { Center, Flex, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { useNewNavigate, usePaidRoomIsValue, usePaymentRoomValue } from "@shared/client";
import { paymentRoomProps, useGetPaymentList } from "@shared/server";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useSearchParams } from "react-router-dom";
import { PaymentForm } from "./paymentForm";
import { SelectedRooms } from "./selectedRooms";

export const Payment = () => {
    const [searchParams] = useSearchParams();
    const uid = searchParams.get("uid");
    const { data } = useGetPaymentList<paymentRoomProps[]>({ uid });
    const { onNavigate } = useNewNavigate();
    const isPaidRoomValue = usePaidRoomIsValue();
    const paidRoomValue = usePaymentRoomValue();

    const { isMobile } = MEDIA();

    useEffect(() => {
        if (!uid || (isPaidRoomValue && paidRoomValue.length === 0)) {
            alert("선택된 객실이 없어 이전 페이지로 돌아갑니다.");
            onNavigate({ path: "/reserve" });
        }
    }, [paidRoomValue]);

    return (
        <>
            <Helmet>
                <title>Marginmax | 결제</title>
            </Helmet>
            {data ? (
                <Center w="100%" maxWidth="768px" flexDir="column" rowGap="16px">
                    <Flex w="100%">
                        <CustomTitle textAlign="left">결제하기</CustomTitle>
                    </Flex>
                    <Center
                        width="100%"
                        flexDir="column"
                        rowGap="24px"
                        border={isMobile ? "none" : `1px solid ${theme.COLOR.gray[300]}`}
                        borderRadius="16px"
                        p={isMobile ? "0" : "24px"}
                    >
                        <SelectedRooms data={data} />
                        <PaymentForm />
                    </Center>
                </Center>
            ) : (
                <Loading h="640px" spinnerSize="xl">
                    결제 정보를 불러오고 있습니다...
                </Loading>
            )}
        </>
    );
};

const CustomTitle = styled(Text)`
    ${FONT("pretendard", 24, 700)}
`;
